"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator_director = exports.signalAction = void 0;
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var voyageGameMode_game_hyperspace_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_game_hyperspace-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
// let _directorTimer = 0
// let _directorTime = 25
// let _adaptiveDifficulty = 0.97 // 0.965
// let _superTestMode = false && voyageTestParams.isDevMode
var _events = ['boarded', 'fire', 'ship', 'nothing', 'hull-breach', 'bomb'];
// if (_superTestMode) {
//   _directorTime = 10
//   _directorTimer = _directorTime
//   // _events = ['fire', 'hull-breach']
//   _events = ['boarded']
// }
function signalAction() {
    // TODO: signal mission?
    //_directorTimer = _directorTime
}
exports.signalAction = signalAction;
function generator_director() {
    var hyper, status_1, mission, r;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                voyageGameStatus_sidecar_1.voyageGameStatus.get().isGameStarted = true;
                voyageGameStatus_sidecar_1.voyageGameStatus.get().isGameEnded = false;
                hyper = voyageGameMode_game_hyperspace_sidecar_1.voyageGameMode_game_hyperspace.generator_hyperspace();
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 11];
                // let ds = common.getUpdateDeltaScaled()
                hyper.next();
                if (!voyageGameMode_game_hyperspace_sidecar_1.voyageGameMode_game_hyperspace.getIsInHyperspace()) return [3 /*break*/, 3];
                return [4 /*yield*/, 0];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3:
                if (!!websockets_sidecar_1.websockets.getIsHost()) return [3 /*break*/, 5];
                return [4 /*yield*/, 0];
            case 4:
                _a.sent();
                return [3 /*break*/, 1];
            case 5:
                status_1 = voyageGameStatus_sidecar_1.voyageGameStatus.get();
                if (!status_1.isGameEnded) return [3 /*break*/, 6];
                return [3 /*break*/, 9];
            case 6:
                mission = status_1.currentMission;
                r = mission.genMission.next();
                if (!r.done) return [3 /*break*/, 7];
                return [3 /*break*/, 9];
            case 7:
                if (!r.value) return [3 /*break*/, 9];
                return [4 /*yield*/, r.value];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, 0];
            case 10:
                _a.sent();
                return [3 /*break*/, 1];
            case 11: return [2 /*return*/];
        }
    });
}
exports.generator_director = generator_director;
